import { Phone, Navigation } from "lucide-react";
import { restaurant, fullAddress } from "../../data/siteData";

export const CallButton = ({ testId = "call-restaurant-button", label = "Appeler le restaurant" }) => (
  <a href={restaurant.phoneHref} data-testid={testId} className="btn-gold">
    <Phone className="w-4 h-4" /> {label}
  </a>
);

export const MapButton = ({ testId = "open-map-button" }) => (
  <a href={restaurant.directionsUrl} target="_blank" rel="noopener noreferrer" data-testid={testId} className="btn-ghost">
    <Navigation className="w-4 h-4" /> Itinéraire
  </a>
);

export const ContactCard = ({ testId = "contact-card" }) => (
  <div className="rounded-3xl border border-[#D4A359]/20 bg-[#123322]/80 p-6 sm:p-9 flex flex-col" data-testid={testId}>
    <h3 className="font-display text-2xl sm:text-3xl text-[#F7F4EB]">Nous trouver</h3>
    <dl className="mt-7 space-y-6">
      <div>
        <dt className="text-[11px] uppercase tracking-[0.25em] text-[#D4A359]">Adresse</dt>
        <dd className="mt-2 text-lg text-[#F7F4EB]" data-testid="contact-address">{fullAddress}</dd>
      </div>
      <div>
        <dt className="text-[11px] uppercase tracking-[0.25em] text-[#D4A359]">Téléphone</dt>
        <dd className="mt-2">
          <a href={restaurant.phoneHref} className="font-display text-3xl sm:text-4xl text-[#F7F4EB] hover:text-[#E5B66C] transition-colors" data-testid="contact-phone-link">
            {restaurant.phone}
          </a>
        </dd>
      </div>
    </dl>
    <div className="mt-auto pt-8 flex flex-wrap gap-3">
      <CallButton testId={`${testId}-call`} />
      <MapButton testId={`${testId}-map`} />
    </div>
  </div>
);
